module.exports = __webpack_public_path__ + "static/media/img1.eb87e93e.jpeg";